import { useAppSelector } from "store/store";

export const useFindTextBox = (id: string) => {
    const textBox = useAppSelector((state) => state.memeGenerator.meme?.textBoxes.find((_t) => _t.id === id));
    if (!textBox) throw new Error(`Invalid textBox id passed: ${id}`);
    return { textBox };
};
